import React from 'react';
import { Card, Row } from 'react-bootstrap';

const LoadWidgetBox = (props) => {
    const { id, selected, title, className, primaryColor,
        secondaryColor, loadCount, icon, onClick } = props;

    return <Card
        className={`load-count-card ${className || ""} ${selected && "selected"} ${selected === false && "unselected"}`}
        {...onClick && { onClick: () => onClick(id) }}
        {...selected && { style: { borderColor: secondaryColor } }}>
        <Row className="m-0">
            <div className="image-type" style={{ backgroundColor: primaryColor }}>
                <i className={`${icon}`} aria-hidden="true" />
            </div>
            <div className="load-details" style={{ backgroundColor: secondaryColor }}>
                <Row className="title">{title}</Row>
                <Row className="count">{loadCount}</Row>
            </div>
        </Row>
    </Card>
};

export default LoadWidgetBox;